import { render, staticRenderFns } from "./AnimationKpis.vue?vue&type=template&id=0166de88&scoped=true&"
import script from "./AnimationKpis.vue?vue&type=script&lang=js&"
export * from "./AnimationKpis.vue?vue&type=script&lang=js&"
import style0 from "./AnimationKpis.vue?vue&type=style&index=0&id=0166de88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166de88",
  null
  
)

export default component.exports